import React from 'react';
import PropTypes from 'prop-types';

import {withI18n} from 'spa/Components/Context';

import Button, {ButtonSizeTypes, ButtonThemeTypes} from '@urbanmassage/component-library/lib/Button/Button';
import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';

import './basket-summary-items.less';

const BasketSummaryItems = ({
  isLoadingRemoveService,
  itemsList,
  onClickRemoveService,
  boxed,
}, { i18n }) => (
  <div className="basket-summary-items" data-testid="basket-summary-items">
    <ul className="basket-summary-items__container">
      {itemsList && itemsList.map((item, index) => (
        <li
          className="basket-summary-items__row"
          key={`basket-summary-items-element-${index}`}
          style={{
            backgroundImage: item.iconUrl ? `url(${item.iconUrl})` : 'none',
          }}
        >
          <div
            className={`basket-summary-items__row-content-wrapper ${boxed ? ' basket-summary-items__row-content-wrapper--boxed' : ''}`}
            data-qa="basket-summary-items-item"
            data-testid="basket-summary-items-item"
          >
            <div
              className="basket-summary-items__row-info-container"
              data-testid="basket-summary-items-item-text-container"
            >
              <Typography component={TypeVariants.h2} variant={TypeVariants.body} theme="darkTitle">
                {item.specialityName}
              </Typography>
              <Typography caps component={TypeVariants.p} variant={TypeVariants.bodySmall} theme="secondary">
                {item.subtitle}
              </Typography>
            </div>
            <div
              className="basket-summary-items__row-button-container"
              data-testid="basket-summary-items-item-button-container"
            >
              <Button
                block
                data-qa="basket-summary-items-remove-service-button"
                data-serviceid={item.id}
                data-testid="basket-summary-items-remove-service-button"
                disabled={isLoadingRemoveService}
                isLoading={isLoadingRemoveService}
                onClick={() => onClickRemoveService(item.id)}
                size={ButtonSizeTypes.small}
                theme={ButtonThemeTypes.grey}
              >
                {i18n._x('Remove', 'Basket remove button')}
              </Button>
            </div>
          </div>
        </li>
      ))}
    </ul>
  </div>
);

BasketSummaryItems.propTypes = {
  isLoadingRemoveService: PropTypes.bool,
  itemsList: PropTypes.shape({
    iconUrl: PropTypes.string,
    id: PropTypes.string.isRequired,
    map: PropTypes.func,
    specialityName: PropTypes.string,
    subtitle: PropTypes.string,
  }).isRequired,
  boxed: PropTypes.bool,
  onClickRemoveService: PropTypes.func.isRequired,
};

BasketSummaryItems.defaultProps = {
  isLoadingRemoveService: false,
  boxed: false,
};

export default withI18n(BasketSummaryItems);



// WEBPACK FOOTER //
// ./spa/Pages/BookingNext/Components/BasketSidePanelSummary/BasketSummaryItems.jsx